export default __webpack_public_path__ + "static/jeroen-circle-8ec548d39bb726a28410e850a44b35ef.png";